var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_21484)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1388_21484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4282 26.7386L14.4291 26.7405C14.7115 27.3793 14.9497 27.9361 14.9497 28.5116C14.9497 29.8232 14.0671 30.941 12.8481 30.9919C12.6894 30.9965 12.536 31.0008 12.3788 31.0008C6.15111 31.0008 1.09993 25.9498 1.09993 19.7174C1.09993 13.485 6.15102 8.43392 12.3834 8.43392C18.6157 8.43392 23.6668 13.485 23.6668 19.7174V19.8381C23.6501 21.2599 22.3475 22.2882 20.8192 22.2882H16.3766C14.99 22.2882 13.8652 23.4131 13.8652 24.7997C13.8652 24.98 13.8864 25.151 13.9163 25.3104L13.9162 25.3104L13.9174 25.3162C14.0147 25.789 14.2112 26.2402 14.3927 26.6569C14.4046 26.6843 14.4165 26.7115 14.4282 26.7386Z",
    fill: "#FDEFD8",
    stroke: "black",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.0778,
    cy: 21.1694,
    r: 1.05607,
    fill: "#FD784C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.51432,
    cy: 15.3354,
    r: 1.05607,
    fill: "#F7AD3C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.3835,
    cy: 12.4018,
    r: 1.05607,
    fill: "#EF5DA8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_1388_21484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.362 14.6747L29.3626 14.6742C29.6612 14.4495 30.0766 14.4717 30.3499 14.7273C30.6242 14.9839 30.675 15.3996 30.4729 15.7124L26.1894 22.3376C26.1892 22.3379 26.1891 22.3381 26.1889 22.3383C25.9043 22.7751 25.4691 23.082 24.9767 23.2084L22.2855 20.7856C22.348 20.2295 22.6368 19.7206 23.0903 19.3805L23.0904 19.3804L29.362 14.6747ZM21.0592 22.1684L23.8163 24.6498C23.7997 25.9995 22.7025 27.0864 21.3489 27.0864H17.5334C17.3406 27.0864 17.1855 26.9314 17.1855 26.7386C17.1855 26.5457 17.3406 26.3907 17.5334 26.3907H17.6606C18.0879 26.3907 18.423 26.1585 18.6275 25.8744C18.8292 25.5942 18.9312 25.2314 18.8946 24.8751L18.8945 24.8739C18.8857 24.7912 18.8813 24.7053 18.8813 24.6189C18.8813 23.3543 19.8347 22.3106 21.0592 22.1684Z",
    fill: "white",
    stroke: "#7647EE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.1982,
    cy: 15.3506,
    r: 1,
    fill: "#47BE79"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.670605 7.25977L3.25061 0.259765H4.14061L6.71061 7.25977H5.82061L5.18061 5.45977H2.20061L1.55061 7.25977H0.670605ZM2.45061 4.77977H4.93061L3.69061 1.31977L2.45061 4.77977ZM9.15592 7.37977C8.74258 7.37977 8.39925 7.30977 8.12592 7.16977C7.85258 7.02977 7.64925 6.8431 7.51592 6.60977C7.38258 6.37643 7.31592 6.1231 7.31592 5.84977C7.31592 5.3431 7.50925 4.9531 7.89592 4.67977C8.28258 4.40643 8.80925 4.26977 9.47592 4.26977H10.8159V4.20977C10.8159 3.77643 10.7026 3.44977 10.4759 3.22977C10.2493 3.0031 9.94592 2.88977 9.56592 2.88977C9.23925 2.88977 8.95592 2.9731 8.71592 3.13977C8.48258 3.29977 8.33592 3.53643 8.27592 3.84977H7.41592C7.44925 3.48977 7.56925 3.18643 7.77592 2.93977C7.98925 2.6931 8.25258 2.50643 8.56592 2.37977C8.87925 2.24643 9.21258 2.17977 9.56592 2.17977C10.2593 2.17977 10.7793 2.36643 11.1259 2.73977C11.4793 3.10643 11.6559 3.59643 11.6559 4.20977V7.25977H10.9059L10.8559 6.36977C10.7159 6.64977 10.5093 6.88977 10.2359 7.08977C9.96925 7.2831 9.60925 7.37977 9.15592 7.37977ZM9.28592 6.66977C9.60592 6.66977 9.87925 6.58643 10.1059 6.41977C10.3393 6.2531 10.5159 6.03643 10.6359 5.76977C10.7559 5.5031 10.8159 5.2231 10.8159 4.92977V4.91977H9.54592C9.05258 4.91977 8.70258 5.00643 8.49592 5.17977C8.29592 5.34643 8.19592 5.55643 8.19592 5.80977C8.19592 6.06977 8.28925 6.27977 8.47592 6.43977C8.66925 6.5931 8.93925 6.66977 9.28592 6.66977Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_1388_21484",
    x: 8.00024,
    y: 10.6673,
    width: 25.9999,
    height: 25.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.333333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1388_21484"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.666667,
    dy: 0.666667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1388_21484",
    result: "effect2_dropShadow_1388_21484"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1388_21484",
    result: "effect3_dropShadow_1388_21484"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 3.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1388_21484",
    result: "effect4_dropShadow_1388_21484"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1388_21484",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_21484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1388_21484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2336,
    height: 23.2336,
    fill: "white",
    transform: "translate(0.766602 8.10059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.9b8def6519d0f2114fa72567842b920e.svg";
export { ForwardRef as ReactComponent };